window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */
theme.Product = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    variantSkuWrapper: '[data-variant-sku-wrapper]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    quantityAndButtonWrapper: '[data-quantity-and-button-wrapper]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        // new
        $(selectors.quantityAndButtonWrapper, this.$container).removeClass('unavailable');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        //$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        // new
        $(selectors.quantityAndButtonWrapper, this.$container).addClass('unavailable');
        $(selectors.addToCartText, this.$container).html(productTranslations.add_to_cart);
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        // new
        $(selectors.quantityAndButtonWrapper, this.$container).removeClass('unavailable');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        // new
        $(selectors.quantityAndButtonWrapper, this.$container).addClass('unavailable');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

// product options with text options that require wider buttons
const wideTextProductOptions = [
  'rod_power',
  'rod_action',
  'color',
  'primary_technique',
  'specialty',
  'rod_handle_material',
  'guide_type',
  'braking_system',
];

const AMPLIENCE_BASE_URL = 'https://media.purefishing.com/s/purefishing/';
const AMPLIENCE_BASE_ASSET_URL = 'https://media.purefishing.com/i/purefishing/';
const SWATCH_SUFFIX = '$pdp_swatch_200$';


let allProductData = {};          // global product data
let currentVariantId = [];
const dynamicProductOptions = []; // product options that users can change
const staticProductOptions = [];  // product options that users cannot change
let productInStock = false;     // gets set after data loads - for global OOS state

// cache DOM to limit lookups
const $dom = {}
const cacheDom = () => {
  $dom.hiddenSelect = $("#json_select");
  $dom.productPriceWrapper = $('[data-product-price-wrapper]');
  $dom.variantSkuWrapper = $('[data-variant-sku-wrapper]');
  $dom.variantModelNoWrapper = $('[data-variant-model-wrapper]');
  $dom.quantityAndButtonWrapper = $('[data-quantity-and-button-wrapper]');
  $dom.addToCart = $('[data-add-to-cart]');
  $dom.addToCartText = $('[data-add-to-cart-text]');
  $dom.optionGroupsWrapper = $('#json_markup');
  $dom.staticOptionsWrapper = $('#static_values');
  $dom.currentVariantWrapper = $('#json_current_variant');

  // specifications
  $dom.sku = $('#json_skuTable');
  $dom.sku2 = $('#json_skuTable2');
  $dom.modelNo = $('#json_modelNoTable');
  $dom.modelNo2 = $('#json_modelNoTable2');
  $dom.specsTable = $('#json_specsTable');
  $dom.specsTable2 = $('#json_specsTable2');
}

var first_variant_upc = "";

// fetch custom collection view with JSON markup for all child products
const fetchAllProductData = () => {
  const groupTag = $('[data-group-tag]').data('groupTag');
  // variants and metafields objects created with collection-json.liquid template
  $.get(`/collections/all/${groupTag}?view=json`)
    .done(function(data) {
      allProductData = JSON.parse(data); // assign to global variable
      if (Object.keys(allProductData.variants).length > 0) { // If the product is available in the customer's region 
        // Set original Locally UPC
        var first_variant = allProductData.variants[Object.keys(allProductData.variants)[0]];
        if(first_variant.standard == "true") {
          first_variant = allProductData.variants[Object.keys(allProductData.variants)[1]];
        }
        first_variant_upc = first_variant.upc;
        
        mapMetafields();
        mapSwatches();
        updateWideTextOptionGroups();
        loadProductData();
        loadSpecsTable();
        singleDynamicOpt();
        checkAvailabilityDates();
      } else { // If the product is not available in the customer's region 
        $dom.variantModelNoWrapper.addClass('out-of-stock');
        $dom.variantModelNoWrapper.append('<span class="oos-hint">- Currently not available in your region.</span>');
      }
  });
}

const filterBySalesTag = async function(groupData){
  let currency = Shopify.currency.active.toLowerCase();
  let products = [];
  let acceptedVariants = [];
  let finalProducts = groupData; // For mutation 

  if ( window.theme.region == "EU" ){
    for (const variant in groupData.variants) {
      let salesOrg = groupData.variants[variant].salesorg;
      if (
        (currency === "usd" && salesOrg.includes("0020")) ||
        (currency === "sek" && salesOrg.includes("0070")) ||
        (currency === "nok" && salesOrg.includes("0070")) ||
        (currency === "eur" && salesOrg.includes("0300")) ||
        (currency === "pln" && salesOrg.includes("0300")) ||
        (currency === "gbp" && salesOrg.includes("0300")) ||
        (currency === "dkk" && salesOrg.includes("0300"))
      ) { 
        // If the sales tag matches the currency, mark the product ID to be accepted
      } else {
        // Remove product from list
        delete finalProducts.variants[variant];
      }
    }
  }

  return finalProducts;
}


// map all metafields (group options + specs)
const mapMetafields = () => {
  const variantIds = Object.keys(allProductData.variants);
  const groupOptionsMap = {};
  const specsMap = {};

  // since some specs are missing on variant-level, we need to gather all specs here
  const allSpecs = []
  variantIds.forEach(id => {
    const variant = allProductData.variants[id];
    if(variant.specs) {
      const specs = Object.keys(variant.specs);
      specs.forEach(spec => {
        if(!allSpecs.includes(spec)) {
          allSpecs.push(spec);
        }
      });
    }
  });
  // assign keys to specs map
  allSpecs.sort().forEach(spec => specsMap[spec] = {});
  // iterate over variants to build group options map + fill in specs map

  variantIds.forEach(id => {
    const variant = allProductData.variants[id];
    if(!variant.standard) {
      // build groupOptionsMap to match the previous data layout (metafields)
      const optionsAndValues = Object.entries(variant['group_options']);
      optionsAndValues.forEach(pair => {
        const option = pair[0];
        const value = pair[1];
        // check if option property exists on map
        if(!groupOptionsMap.hasOwnProperty(option)) {
          groupOptionsMap[option] = {};
          groupOptionsMap[option][value] = [id];
        } else {
          // option property exists, check for value
          if(!groupOptionsMap[option].hasOwnProperty(value)) {
            groupOptionsMap[option][value] = [id]; // create + populate array
          } else {
            groupOptionsMap[option][value].push(id); // add to existing array
          }
        }
      });
      // fill in specsMap to match the previous data layout
      allSpecs.forEach(spec => specsMap[spec][id] = variant.specs.hasOwnProperty(spec) ? variant.specs[spec] : ""); // use blank cell value if it's not listed on variant
    }
  });
  // set to match former data structure maximize working code
  allProductData.metafields = groupOptionsMap;
  allProductData.specs = specsMap;
}

// build a map to quickly access swatch data
const mapSwatches = () => {
  const colorMediaMap = {};
  const colors = allProductData.colors.filter(color => color.includes(':'));
  colors.map(str => {
    const parts = str.split(':');
    colorMediaMap[parts[0]] = parts[1];
  });
  allProductData.mediaMap = colorMediaMap;
}

/*
  count characters in each option value.
  groups with any value over 10 characters are
  added to the wideTextProductOptions array
*/
const updateWideTextOptionGroups = () => {
  const additionalWideGroups = [];
  const groups = Object.keys(allProductData.metafields);
  groups.forEach(group => {
    const values = Object.keys(allProductData.metafields[group]);
    for(let i = 0; i < values.length; i++) {
      if(values[i].length > 7) {
        additionalWideGroups.push(group);
        break;
      }
    }
  })
  additionalWideGroups.forEach(group => {
    if(!wideTextProductOptions.includes(group)) {
      wideTextProductOptions.push(group);
    }
  });
}

// build all product variant / options
const loadProductData = () => {
  const variants = allProductData.variants,
    metafields = allProductData.metafields,
    currentVariant = $dom.currentVariantWrapper.text().trim(),
    variantCount = Object.keys(variants).length;
    
  checkInventory(); // check the inventory of child variants

  if(!productInStock && window.theme.commerceEnabled == true && !JSON.parse($('[data-product-json]', this.$container).html()).tags.includes('online:60')) showOOSTag(); // show out of stock tag if entire product is OOS and commerce is enabled

  $.when(
    // create options for each product on the hidden form
    $.each(variants, function (key, data) {
      const option = $("<option />");
      option.html(this.title);
      option.val(key);
      $dom.hiddenSelect.append(option);
    })
  ).then(function(){
    // select the variant for standard Shopify products with only one variant
    if (variantCount === 1) {
      updateVariantPageData(currentVariant, true, true); // passing the singleVariantProduct = true param
    } else if (variantCount == 2) {
      // if there are 2 variants, differentiate the child from the shell/parent variant
      let childVariantId;
      $.each(variants, function (key, variant) {
        if(variant.standard != "true") childVariantId = key;
      });
      // set data for one-variant product (since shell should be ignored)
      updateVariantPageData(childVariantId, true);
    } else if (currentVariant !== '') {
      // preselect options with current variant data
      const preselections = variants[currentVariant]['group_options'];
      $('.metafield_group span.box').removeClass('active');
      $.each(preselections, function(key, value) {
        $(`.metafield_group span.box[data-metafield="${key}"][data-value="${value}"]`).addClass('active');
      });
      updateVariantPageData(currentVariant, true);
    } else {
      if(first_variant_upc.length) {
        if(typeof lcly_reload_0 !== "undefined") {
          lcly_reload_0({ 'upc' : first_variant_upc });
        } else {
          setTimeout(function() {
            if(typeof lcly_reload_0 !== "undefined") {
              lcly_reload_0({ 'upc' : first_variant_upc });
            }
          }, 1000)
        }
      }
    }

    // no option states to initialize if there's only one real product
    if(variantCount <= 2) return;

    initOptionStates(); // trigger update with simulated first option click
  });

  // construct markup for the option groups
  buildOptionGroups(metafields);

  // main listener for option selection
  $(document).on('click tap', '.metafield_group span.box', handleOptionSelect);
}

// checks for any in-stock variants, otherwise it will set a 'global OOS' state
const checkInventory = () => {
  const variants = allProductData.variants;
  // rule out the shell variant + check for availability of others
  for(id in variants) {
    if(variants[id].available && !variants[id].standard) {
      productInStock = true;
      return;
    }
  }
  // nothing is in stock
  productInStock = false;
  return;
}

// build markup for dynamic option groups
const buildOptionGroups = metafields => {
  let hasColorOption = false;
  
  var item_order = optionOrdering.split(",");
  
  console.log(item_order);
  $.each(metafields, function (key, value) {
    if(!item_order.includes(key)) {
      item_order.push(key);
    }
  });
  console.log(item_order);

  $.each(item_order, function (order_key, key) {
    let value = metafields[key];
    if(typeof value === "undefined") {
      return;
    }
//   $.each(metafields, function (key, value) {
    let markup = '';
    let static_markup = '';

    const handle = key.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    var option_label = key.replace(/\_/g, ' ');

    // check to see if we have a translation for the option label
    if(typeof facets_translations !== "undefined") {
      var option_search = option_label.toLowerCase().split(' ').map(
        word => word.charAt(0).toUpperCase() + word.substring(1)
      ).join(' ')
      if(option_search in facets_translations) {
        option_label = facets_translations[option_search].translation;
      }
    }
    
    const value_count = Object.keys(value).length;

    if (value_count === 1) {
      // add to static product options array (to be used when setting up logic)
      staticProductOptions.push(key); // might not need this (dynamic is what matters)
      // build static option
      var readable_value = Object.keys(value)[0].replace(/#/g, '\'').replace(/\$/g,'\"').replace(/\_/g, ' ');

      // check to see if we have a translation
      if(typeof facets_translations !== "undefined") {
        if(readable_value in facets_translations[option_search].options) {
          readable_value = facets_translations[option_search].options[readable_value];
        }
      }
      
      static_markup += (readable_value !== 'None') ? `
        <div class="select-row">
          <div class="row-title">
            <span class="label">
              ${option_label}: <span>${readable_value}</span>
            </span>
          </div>
        </div>` : '';
    } else {
      // add to dynamic product options array (to be used for selection logic)
      dynamicProductOptions.push(key);
      // check key against wide product option options
      const isWideOption = $.inArray(key, wideTextProductOptions) != -1;
      if(key === 'color') hasColorOption = true;

      // add each option button to the markup
      const buildOptionsMarkup = () => {
        let optionButtons = '';
        value = Object.keys(value).sort(function (a, b) {
          var isNumber = function (v) { return (+v).toString() === v; },
              aa = a.match(/\d+|\D+/g),
              bb = b.match(/\d+|\D+/g),
              i = 0,
              l = Math.min(aa.length, bb.length);

          while (i < l && aa[i] === bb[i]) {
              i++;
          }
          if (i === l) {
              return aa.length - bb.length;
          }
          if (isNumber(aa[i]) && isNumber(bb[i])) {
              return aa[i] - bb[i];
          }
          return aa[i].localeCompare(bb[i]);
      }).reduce(
          (obj, key) => { 
            obj[key] = value[key]; 
            return obj;
          }, 
          {}
        );
        $.each(value, function (k, v) {
          var readable_value = k.replace(/#/g, '\'').replace(/\$/g,'\"').replace(/\_/g, ' ');
          // check to see if we have a translation
          if(typeof facets_translations !== "undefined") {
            if(typeof facets_translations[option_search] !== "undefined" && readable_value in facets_translations[option_search].options) {
              readable_value = facets_translations[option_search].options[readable_value];
            }
          }
          const isColor = key === 'color';
          const isFrameColor = key === 'frame_color';
          const isLensColor = key === 'lens_color';
          if (isLensColor) {
            readable_value = "lens_" + readable_value;
          }
          if (isFrameColor) {
            readable_value = "frame_" + readable_value;
          }
          const mediaIdentifier = allProductData.mediaMap[readable_value];
          const backgroundImage = allProductData.variants[v[0]].imageUrl;
          
//           console.log("-----");
//           console.log(key);
//           console.log(readable_value);
//           console.log(allProductData.mediaMap);
//           console.log(mediaIdentifier);
//           console.log(backgroundImage);
          
          if (mediaIdentifier) {
            var swatchBackgroundStyle = "";
            if(isColor | isFrameColor) {
              swatchBackgroundStyle = `background-image: url('${AMPLIENCE_BASE_URL}${mediaIdentifier}?${SWATCH_SUFFIX}')`;
            } else if(isLensColor) {
              swatchBackgroundStyle = `background-image: url('${AMPLIENCE_BASE_ASSET_URL}${mediaIdentifier}?${SWATCH_SUFFIX}')`;
            }
                   
            optionButtons += (isColor | isFrameColor | isLensColor) 
               ? `<span tabindex="0" class="box" data-metafield="${key}" data-value="${k}">
                   <div class="swatch-wrapper">
                     <div class="swatch-image" style="${swatchBackgroundStyle}"></div>
                   </div>
                 </span>`
               : `<span tabindex="0" class="box" data-metafield="${key}" data-value="${k}">
                   <span>${readable_value}</span>
                 </span>`;
          } else {
            const backgroundImageStyle = backgroundImage ? `background-image: url('${backgroundImage}')` : '';
          
            optionButtons += (isColor | isFrameColor | isLensColor) 
             ? `<span tabindex="0" class="box" data-metafield="${key}" data-value="${k}">
                  <div class="swatch-wrapper">
                    <div class="swatch-image" style="${backgroundImageStyle}"></div>
                  </div>
                </span>`
             : `<span tabindex="0" class="box" data-metafield="${key}" data-value="${k}">
                 <span>${readable_value}</span>
               </span>`;
          }
        });

        return optionButtons;
      }

      // translate the label
      var label_translation = key.replace(/\_/g, ' ');
      if(typeof facets_translations !== "undefined") {
        var key_option_search = key.replaceAll("_"," ").toLowerCase().split(' ').map(
          word => word.charAt(0).toUpperCase() + word.substring(1)
        ).join(' ');
        if(key_option_search in facets_translations) {
          label_translation = facets_translations[key_option_search].translation;
        } 
      } 
      
      // build option groups
      markup += `
      <div class="select-row ${key === 'color' ? 'swatch-row': ''}" data-option-group="${key}">
        <div class="row-title">
          <span class="label">
            ${label_translation}: <span></span>
          </span>
          <span class="tooltip" rel="${handle}">` + productTranslations.need_help + `?</span>
        </div>
        <div class="boxes metafield_group ${isWideOption ? 'wide' : ''} ${ (key === 'color' || key === 'frame_color' || key === 'lens_color') ? 'swatches' : ''}">
          ${buildOptionsMarkup()}
        </div>
      </div>`;
    }

    $dom.staticOptionsWrapper.append(static_markup);
    $dom.optionGroupsWrapper.append(markup);

    if (hasColorOption) {
      // hide/show the opaque bottom row of color swatches
      const colorSwatchContainer = document.querySelector(".swatch-row .boxes");
      const colorSelectRow = colorSwatchContainer.parentElement;
      let scrollableWidth = colorSwatchContainer.scrollWidth - colorSwatchContainer.clientWidth;
      let scrollableHeight = colorSwatchContainer.scrollHeight - colorSwatchContainer.clientHeight;
      let hasHorizontalScrollbar = scrollableWidth > 0; // mobile option
      let hasVerticalScrollbar = scrollableHeight > 0; // desktop option

      // hide opacity if scrollbar is not needed (initially)
      if(window.innerWidth > 768) {
        if(!hasVerticalScrollbar) colorSelectRow.classList.add("no-opacity");
      } else {
        if(!hasHorizontalScrollbar) colorSelectRow.classList.add("no-opacity");
      }

      // reset the scroll height/width needed to trigger opacity block to disappear
      window.onresize = site.helpers.debounce(() => {
        colorSelectRow.classList.remove("no-opacity"); // reset opacity block
        scrollableWidth = colorSwatchContainer.scrollWidth - colorSwatchContainer.clientWidth;
        scrollableHeight = colorSwatchContainer.scrollHeight - colorSwatchContainer.clientHeight;
        hasHorizontalScrollbar = scrollableWidth > 0; // mobile option
        hasVerticalScrollbar = scrollableHeight > 0; // desktop option
        // hide opacity if scrollbar is not needed (initially)
        if(window.innerWidth > 768) {
          if(!hasVerticalScrollbar) colorSelectRow.classList.add("no-opacity");
        } else {
          if(!hasHorizontalScrollbar) colorSelectRow.classList.add("no-opacity");
        }
      }, 250);

      colorSwatchContainer.onscroll = () => {
        if (window.innerWidth > 768) {
          // hide opacity block if there's no scrollbar needed
          if(!hasVerticalScrollbar) { 
            colorSelectRow.classList.add("no-opacity");
            return;
          }
          (scrollableHeight - colorSwatchContainer.scrollTop < 50)
            ? colorSelectRow.classList.add("no-opacity")
            : colorSelectRow.classList.remove("no-opacity");
        } else {
          // hide opacity block if there's no scrollbar needed
          if(!hasHorizontalScrollbar) {
            colorSelectRow.classList.add("no-opacity");
            return;
          }
          (scrollableWidth - colorSwatchContainer.scrollLeft < 50)
            ? colorSelectRow.classList.add("no-opacity")
            : colorSelectRow.classList.remove("no-opacity");
        }
      };
    }
  });
}

// refresh all variant-specific data on the page (ATC, prices, etc.)
const updateVariantPageData = (variant_id, initialPageLoad = false, singleVariantProduct = false) => {

  if (!variant_id || singleVariantProduct) return;

  const variants = allProductData.variants,
    availability = variants[variant_id].available,
    variant_sku = variants[variant_id].sku,
    variant_model_no = variants[variant_id].model_no;

  var variant_price = variants[variant_id].price;
  var variant_compare_at = variants[variant_id].compare_at;
  
  // Update lcly UPC
  var variant_upc = variants[variant_id].upc;
  if(typeof lcly_reload_0 !== "undefined") {
    lcly_reload_0({ 'upc' : variant_upc });
  } else {
    setTimeout(function() {
      if(typeof lcly_reload_0 !== "undefined") {
        lcly_reload_0({ 'upc' : variant_upc });
      }
    }, 1000)
  }

  // Get currency pricing
  if ( window.theme.region != "US" ){
    var currency = Shopify.currency.active.toLowerCase();
    if(typeof variants[variant_id].pricing !== 'undefined' && typeof variants[variant_id].pricing[currency] !== 'undefined')
    {
      variant_price = slate.Currency.formatMoney(variants[variant_id].pricing[currency], theme.moneyFormat)
    } else {
      // No pricing available in this currency.
      variant_price = "";
    }
  }

  /**************
    Matt's GTM updates

    Cam notes: 
      - finding the master product only needs to happen once, not every time the variant changes. this should be updated
  ***************/ 
  // Get master product
  let masterVariantId;
  $.each(variants, function (key, variant) {
    if(variant.standard === "true") {
      masterVariantId = key;
    }
  });
  const product = variants[masterVariantId];
//   const brands = allProductData.specs.brand;
//   const vendor = brands[Object.keys(brands)[0]];
  let vendor = "Pure Fishing";
  if(typeof ShopifyAnalytics !== 'undefined' &&
    typeof ShopifyAnalytics.meta !== 'undefined' &&
    typeof ShopifyAnalytics.meta.product !== 'undefined' &&
    typeof ShopifyAnalytics.meta.product.vendor !== 'undefined')
  {
    vendor = ShopifyAnalytics.meta.product.vendor;
  }
  
  // Set current variant in dataLayer
  window.dataLayer.push({
    "event": "productVariantView",
    "ecommerce": {
      "detail": {
        "products": [{
          "name": product.title.replace("'", ''),
          "masterId": product.sku,
          "id": variant_sku,
          "productId": masterVariantId,
          "variantId": variant_id,
          "shopifyId": "shopify_US_" + masterVariantId + "_" + variant_id,
          "price": parseFloat(variant_price.replace(/\$/g, '')),
          "brand": vendor.replace("'", ''),
          "variant": product.title.replace("'", '')
        }]
      }
    }
  });
  
  window.dataLayer.push({
    "VariantCompareAtPrice": parseFloat(variant_compare_at.replace(/\$/g, '')),
    "VariantPrice": parseFloat(variant_price.replace(/\$/g, '')),
    "shopifyProductId": "shopify_US_" + masterVariantId + "_" + variant_id
  });
  /**************
    End GTM updates
  ***************/ 

  // set the current variant as selected on product form
  $dom.hiddenSelect.val(variant_id);
  
  // update add to cart state
  if (availability == true) {
    $dom.quantityAndButtonWrapper.removeClass('unavailable');
    $dom.addToCart.prop('disabled', false);
    $dom.addToCartText.text(productTranslations.add_to_cart);
  } else {
    $dom.quantityAndButtonWrapper.addClass('unavailable');
    $dom.addToCart.prop('disabled', true);
    $dom.addToCartText.text(productTranslations.out_of_stock);
  }

  // update sku + model number
  $dom.variantSkuWrapper.text('SKU ' + variant_sku);
  if(variant_model_no) {
    $dom.variantModelNoWrapper.text(productTranslations.model_number_short + variant_model_no);
    $dom.variantModelNoWrapper.show();
  } else {
    $dom.variantModelNoWrapper.hide();
  }

  // update out of stock model indicator
  if(!availability && theme.commerceEnabled && !JSON.parse($('[data-product-json]', this.$container).html()).tags.includes('online:60')) {
    $dom.variantModelNoWrapper.addClass('out-of-stock');
    $dom.variantModelNoWrapper.append('<span class="oos-hint">- '+productTranslations.not_in_stock+'</span>');
  } else {
    $dom.variantModelNoWrapper.removeClass('out-of-stock');
  }
  
  // update price
  var price_markup = "";
  if(theme.commerceEnabled) {
    if(variant_compare_at != '') {
      price_markup = `<span class="visually-hidden" data-compare-text>${variant_compare_at}</span>
      <s data-compare-price>${variant_compare_at}</s>
      <span class="on-sale" data-product-price>${variant_price}</span>`;
    } else {
      price_markup = `<span data-product-price>${variant_price}</span>`;
    }
  } else if(theme.showPriceWhenCommerceDisabled) {
    if(variant_compare_at != '') {
      price_markup = `<span data-product-price>${variant_compare_at}</span>`;
    } else {
      price_markup = `<span data-product-price>${variant_price}</span>`;
    }
  } else {
    // Display no pricing
  }
  $dom.productPriceWrapper.html(price_markup);

  const oldAmpSet = $('#amp-container').data('setName');
  const newAmpSet = variants[variant_id].amplience;

  // update amplience gallery if gallery set name is different from the current one
  // TODO: add a color condition here (for if a new swatch is selected) to also trigger this
  if (oldAmpSet !== newAmpSet) {                
    setupAmplience(newAmpSet);
  }

  // update variant in url for consistency
  const new_url = `${ productTranslations.base_shop_path }products/${ variants[variant_id].handle }?variant=${ variant_id }`;
  window.history.replaceState({},'', new_url);

  // set the active option labels here (on initial page load only)
  if(initialPageLoad) {
    const $optionGroups = $('[data-option-group]');
    $.each($optionGroups, (key, group) => {
      const optionValue = $(group).find('.active').data('value');
      const readableValue = String(optionValue).replace(/#/g, '\'').replace(/\$/g,'\"').replace(/\_/g, ' ');
      $(group).find('.row-title .label span').text(readableValue);
    })
  }
}

// main function that runs whenever an option is selected
const handleOptionSelect = event => {
  const selectedBox = event.currentTarget,
    selectedCategory = $(selectedBox).data('metafield'),
    selectedValue = $(selectedBox).data('value'),
    // get the variants that match the selected option (ie. Gear Ratio: 5.3:1)
    matchingVariantIds = allProductData.metafields[selectedCategory][selectedValue];

  // decide which matched variant to use for updating purposes
  const matchedVariantId = decideMatchingVariantId(matchingVariantIds, selectedCategory);
  // update page elements (ATC, price, etc.) to reflect first matching variant
  updateVariantPageData(matchedVariantId);
  // update all option states based on what was last selected
  updateOptionStates(selectedBox, selectedCategory, matchedVariantId, matchingVariantIds);
}

// TODO: simplify this logic - possibly get rid of it if top-down option priority is preferred by client
// takes array of IDs of variants containing new selection and cross-checks other
// option groups so as not to force the selector off of a previous valid choice
const decideMatchingVariantId = (matchingVariantIds, selectedCategory) => {
  const variants = allProductData.variants;
  let matchedVariantId = matchingVariantIds[0];
  // if there's only one match (common case), return it
  if(matchingVariantIds.length === 1) { 
    return matchedVariantId;
  }
  // set up an object to track variants' shared options among those the user hasn't changed
  const sharedOptionsByVariant = {};
  dynamicProductOptions
    .filter(category => category !== selectedCategory)
    .forEach(category => {
      // check if currently selected option on other groups will work with one of the matching variants
      const currentOptionValue = $(`[data-option-group="${category}"] .box.active`).data('value');
      matchingVariantIds.forEach(id => {
        if(variants[id]['group_options'][category] === currentOptionValue) {
          // current option value works with new combo; increment shared option counter
          sharedOptionsByVariant[id] 
          ? sharedOptionsByVariant[id]++ 
          : sharedOptionsByVariant[id] = 1;
        }
      });
  });

  // select the variant with the most shared options (if applicable)
  // otherwise use the original matched variant
  const entries = Object.entries(sharedOptionsByVariant);
  const nonZeroSharedEntries = entries.filter(pair => pair[1] > 0);

  if(!nonZeroSharedEntries.length) {
    return matchedVariantId;
  } else if (nonZeroSharedEntries.length === 1) {
    // if only one variant shares option, use that as matched variant
    matchedVariantId = nonZeroSharedEntries[0][0];
  } else {
    // if there are multiple variants with shared options,
    // sort them to find the matching variant with the most shared options
    matchedVariantId = nonZeroSharedEntries.sort((a, b) => (b[1] > a[1]) ? 1 : -1)[0][0];
  }

  return matchedVariantId;
}

// add Out of Stock tag above title to signify entire product is OOS
const showOOSTag = () => {
  $('[data-tags]').append('<div class="tag out-of-stock">'+productTranslations.out_of_stock+'</div>'); 
}

// disable all options - used in the event that all SKUs are OOS
const disableAllOptions = () => {
  if(theme.commerceEnabled) {
    const buttons = document.querySelectorAll('span.box');
    buttons.forEach(button => {
      button.classList.add('fully-disabled');
    });
  }
}

// first page load option updates (simulates a click on the first option group)
const initOptionStates = () => {
  if(productInStock) {
    const firstSelectedBox = document.querySelector('.box.active');
    const firstBoxValue = firstSelectedBox.dataset.value;
    const firstCategory = firstSelectedBox.dataset.metafield;
    const currentVariant = $('#json_current_variant').text().trim();
    const matchingVariants = allProductData.metafields[firstCategory][firstBoxValue];
    updateOptionStates(firstSelectedBox, firstCategory, currentVariant, matchingVariants);
  } else {
    // they're all out of stock, disable all buttons
    disableAllOptions();
  }
}

// update all option selectors based on available variant combinations
const updateOptionStates = (selectedBox, selectedCategory, matchedVariantId, matchingVariantIds) => {
  const variants = allProductData.variants;
  // remove active classes from all the boxes in the selected group
  $(selectedBox).siblings().removeClass('active');
  /* 
    remove the currently selected box's availability classes, since
      by clicking the box we are resetting the availability mapping
  */
  selectedBox.classList.remove('unavailable', 'out-of-stock');

  /* select the options present on the matching variant 
      -- this handles the "active" class --
  */
  const matchedVariant = variants[matchedVariantId];
  dynamicProductOptions.forEach(category => {
    const optionValue = matchedVariant['group_options'][category];
    const readableValue = String(optionValue).replace(/#/g, '\'').replace(/\$/g,'\"').replace(/\_/g, ' ');
    const $categoryBoxes = $(`[data-option-group="${category}"] .box`);
    const $label = $(`[data-option-group="${category}"] .row-title .label span`);
    // clear active classes
    $categoryBoxes.removeClass('active'); 
    // set the active box
    $categoryBoxes.filter(`[data-value="${optionValue}"]`).addClass('active');
    // update the group label w/ readable value
    $label.text(readableValue);
  });
    
  // Update Available Date on Buy Box
  updateAvailabilityDates(selectedBox, selectedCategory, matchedVariantId, matchingVariantIds);

  /* 
      use the last selected option value to determine
      the availability of all corresponding option values
      (ex. if user clicks 'Gear Ratio: 5.6:1', 
        what Reel Sizes are available for that gear ratio?)

      -- this handles the "unavailable" and "out-of-stock" classes --
  */
  // iterate over options that are also available on the matching variants
  dynamicProductOptions.forEach(category => {
    const existingOptionValues = {};
    // iterate over matching variants to check which of the other option groups exist for current selection
    matchingVariantIds.forEach(id => {
      // determine if option value is present on matching variants
      const optionValue = variants[id]['group_options'][category];
      const variantAvailable = variants[id].available;
      if(optionValue !== undefined) {
        // set availability on existing values object (don't overwrite any true values from other variants)
        if(!existingOptionValues.hasOwnProperty(optionValue)
          || existingOptionValues[optionValue] === false) {
          existingOptionValues[optionValue] = variantAvailable
        }
      }
    });

    // update the availability states of the option boxes in the DOM
    if(theme.commerceEnabled) {
      const $optionBoxes = $(`[data-option-group="${category}"] .box`);
      $.each($optionBoxes, (key, box) => {
        const boxValue = $(box).data('value');
        box.classList.remove('unavailable', 'out-of-stock');
        if(!existingOptionValues.hasOwnProperty(boxValue)) {
          box.classList.add('unavailable');
        } else {
          if(existingOptionValues[boxValue] === false){
            box.classList.add('out-of-stock');
          }
        }
      })
    }
  });
}

// build all specs markup
const loadSpecsTable = () => {

  const specsTable = allProductData.specs_table;
  const specs = allProductData.specs;
  let specsMarkup = '';
  
  const skipSpecs = ['ecommerce_status_date'];
  
  $.each(specs, function (j, i) {
    if(!skipSpecs.includes(j)) {
      var option_label = j.replace(/\_/g, ' ');

      // check to see if we have a translation for the option label
      if(typeof facets_translations !== "undefined") {
        var option_search = option_label.toLowerCase().split(' ').map(
          word => word.charAt(0).toUpperCase() + word.substring(1)
        ).join(' ')
        if(option_search in facets_translations) {
          option_label = facets_translations[option_search].translation;
        }
      }

      specsMarkup += `<tr><th class="head"><span>${option_label}</span></th>`;
      $.each(i, function (l, m) {
        var readable_value = m.replace(/#/g, '\'').replace(/\$/g,'\"').replace(/\_/g, ' ');

        // check to see if we have a translation
        if(typeof facets_translations !== "undefined") {
          if(typeof facets_translations[option_search] !== "undefined" && readable_value in facets_translations[option_search].options) {
            readable_value = facets_translations[option_search].options[readable_value];
          }
        }

        specsMarkup += `<td>${readable_value}</td>`;
      });
      specsMarkup += '</tr>';
    }
  });

  $.each(specsTable, function (key, value) {
      let skuMarkup = '';
      let modelNoMarkup = '';
      let variantHandle = allProductData.variants[key].handle;

      $.each(value, function (k, v) {
        switch(k) {
          case 'model_no':
            modelNoMarkup += `<td><a href='/products/${variantHandle}'>${v}</a></td>`;
            break;
          case 'sku':
            skuMarkup += `<td><a href='/products/${variantHandle}'>${v}</a>`;
            break;
          case 'downloads':
            skuMarkup += (v !== '')
              ? `<a href="${v}" target="_blank">View Schematic</a></td>`
              : '</td>';
            break;
          default: // fallback
        }
      });
      $dom.modelNo.append(modelNoMarkup);
      $dom.modelNo2.append(modelNoMarkup);
      $dom.sku.append(skuMarkup);
      $dom.sku2.append(skuMarkup);
  });
  
  $dom.specsTable.append(specsMarkup);
  $dom.specsTable2.append(specsMarkup);

  if(Object.keys(allProductData.variants).length < 4){
    $('.custom-scrollbar').mCustomScrollbar("disable", true);
    $('.template-product .specs-table .gradient').css('display','none');
  } else {
    $('.custom-scrollbar').mCustomScrollbar({
      axis:"x",
      scrollInertia: 0,
      mouseWheel:{ axis: "x", invert: true },
      scrollbarPosition: "outside",
      documentTouchScroll: true,
      callbacks:{
        whileScrolling:function(){
          if (this.mcs.leftPct == 100) {
            $('.template-product .specs-table .gradient').fadeOut(300);
          } else {
            $('.template-product .specs-table .gradient').fadeIn(300);
          }
        }
      }
    });
  }
}

// set up amplience gallery
// no param = initial load, pulls amplience set from DOM element
const setupAmplience = (newAmpSet) => {
  const $ampWrapper = $('#amp-container');
  let ampSet = '';

  if (!$ampWrapper.length) {
  	return;
  }
  
  if(newAmpSet) {
    // build new gallery
    $ampWrapper.html('');
    ampSet = newAmpSet;
  } else {
    // setup initial gallery on page load
    ampSet = $ampWrapper.data('setName');
  }

  // Alt tag for amplience viewer
  function productAltTag(){
    let Json = $('[data-product-json]').text(),
    index = 0;
    const data = $.parseJSON(Json),
    productTitle = data.title,
    images = $($ampWrapper).find('.amp-image');
    images.each(function(){
      index = index + 1;
      $(this).attr('alt', productTitle + ' - Image ' + index);
    });
  }

  // load amplience gallery set
  const viewerSettings = {
    client: 'penn',
    imageBasePath: '//media.purefishing.com/',
    set: ampSet,
    zoomInlineDoubleTap: false,
    initCallback: function(){
      if($('.desktop-full-view').length) {
        $('.amp-viewer-kit').append('<div class="desktop_overlay-view"></div>');
      }
      productAltTag();
    },
    templates: {
      thumb: 'w=300&h=300'
    },
    tooltips: {
      displayTime: 1000
    },
    ampConfigs: {
      mainContainerCarousel: {
        gesture: {
          enabled: true,
          fingers: 1,
          dir: 'horz',
          distance: 50
        }
      }
    }
  };
  const viewer = new amp.Viewer(viewerSettings);
  $ampWrapper.data('setName', newAmpSet);
}

// set up UI event listeners (tooltip toggles, etc.)
const setupUIListeners = () => {
  // open tool tip
  $(document).on('click tap', '.template-product .tooltip', function(e) {
    e.stopPropagation();
    e.preventDefault();
    var rel = $(this).attr('rel');
    $('.option-popup.popup-' + rel).fadeIn(300);
  });
  
  // close tool tip
  $(document).on('click tap', '.option-popup .close-popup', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.option-popup').fadeOut(300);
  });

  // ADA - enter = click
  $(document).on('keydown', '.box', function(e) {
    if (e.keyCode == 13) {
      $(this).trigger('click');
    }
  });

  // show more boxes on mobile
  $('.readmore .toggle').on('click tap', function() {
    var $this, $parent, $box, totalHeight, baseHeight;

    $this = $(this);
    $parent = $this.parent();
    $box = $parent.parent();
    totalHeight = $box.find('.content').outerHeight();
    baseHeight = 230;
    // selects PDP specs table if it exists
    $pdpSpecsTable = $('.specs-table') ? $('.specs-table') : null

    // if PDP specs table exists, toggle the CSS to allow pointer events
    if ($pdpSpecsTable) {
      $pdpSpecsTable.css('pointer-events', 'all')
    }

    if ($box.hasClass('tall')) {
      baseHeight = 300;
    }

    if ($box.hasClass('is-open')) {
      $box.removeClass('is-open').animate({
        "max-height": baseHeight
      });
      $parent.css('height', 130);
      $this.html('<span>+</span> Show More');
    } else {
      $box.addClass('is-open').css({
      "height": $box.height(),
      "max-height": totalHeight
    }).animate({
      "height": totalHeight
    });
      $parent.css('height', 46);
      $this.html('<span>–</span> Show Less');
    }
  });
}

// OOS states for products with a single variant option to select
const singleDynamicOpt = () => {
  if(theme.commerceEnabled) {
    var variants = allProductData.variants;
    if(dynamicProductOptions.length == 1) {
      for (id in variants){
        const $optionBoxes = $(`[data-option-group="${dynamicProductOptions[0]}"] .box`);
        $.each($optionBoxes, (key, box) => {
          const dataMetafield = $(box).data('metafield').toLowerCase();
          const dataValue = $(box).data('value').toString();
          if(variants[id].specs != undefined){
            const boxValue = variants[id].specs[dataMetafield];
            if(dataValue.toLowerCase() == boxValue.toLowerCase()){
              if(!variants[id].available){
                $(box).addClass('out-of-stock');
              }
            }
          }
        })
      }
    }
  }
}

// Update Availability date on PDP when date is in future
const updateAvailabilityDates = (selectedBox, selectedCategory, matchedVariantId, matchingVariantIds) => {
  const selectedVariant = allProductData.variants[matchedVariantId];
  const purchaseDate = selectedVariant.purchase_on;
  const availableDate = selectedVariant.availability_date;
  if(purchaseDate != null || purchaseDate != undefined){
    let array = purchaseDate.split('');
    array.splice(4, 0, '/');
    array.splice(7, 0, '/');
    const date = new Date(array.join(''));
    const d = new Date(date);
    const today = new Date();
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    const finalDate = [month, day, year].join('/');
      
    if(d > today && !selectedVariant.available) {
      $('.available_date--text').html('Available on ' + finalDate);
    } else {
      $('.available_date--text').empty();
    }
    $('.available_soon').remove();
  } else if(availableDate != null || availableDate != undefined) {
    let array = availableDate.split('');
    array.splice(4, 0, '/');
    array.splice(7, 0, '/');
    const date = new Date(array.join(''));
    const d = new Date(date);
    const today = new Date();
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    const finalDate = [month, day, year].join('/');
    if(d > today && !selectedVariant.available) {
      $('.available_date--text').html('Available on ' + finalDate);
    } else {
      $('.available_date--text').empty();
    }
    $('.available_soon').remove();
  }
}

// Availability date on PDP when date is in future
const checkAvailabilityDates = () => {
  let available = true,
  empty = false;
  const variants = allProductData.variants,
  masterProduct = Object.values(variants).filter(v => v.standard)[0],
  purchaseDate = masterProduct.purchase_on,
  availableDate = masterProduct.availability_date;
  if(purchaseDate) {
    let array = purchaseDate.split('');
    array.splice(4, 0, '/');
    array.splice(7, 0, '/');
    const date = new Date(array.join('')),
    d = new Date(date),
    today = new Date();
      
    if(d > today) {
      available = true;
    } else {
      available = false;
    }
  } else if(availableDate) {
    let array = availableDate.split('');
    array.splice(4, 0, '/');
    array.splice(7, 0, '/');
    const date = new Date(array.join('')),
    d = new Date(date),
    today = new Date();
    if(d > today) {
      available = true;
    } else {
      available = false;
    }
  } else if(!purchaseDate && !availableDate) {
    empty = true;
  }
  if(available && !empty) {
    $('.tags').append('<span class="tag available_soon">Available Soon</span>');
  }
}

// initialize all scripts
const initProductScripts = () => {
  // exit if not on product template
  if(!$('body').is('.template-product')) return;
  fetchAllProductData();
  cacheDom();
  setupAmplience();
  setupUIListeners();
}

// do the things!
initProductScripts();

theme.Cart = (function(){
    $(".js-appendaroundContent").appendAround();
})();
// Slideshow homepage
$('.slideshow').slick({
    dots: true,
    autoplay: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Prev" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#FFFFFF" fill-rule="nonzero"></path></svg></button>',
    nextArrow: '<button id="slick-next" class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#FFFFFF" fill-rule="nonzero"></path></svg></button>',
    responsive: [
        {
            breakpoint: 825,
            settings: {
                arrows: false,
            }
        }
    ]
});

// Featured collection homepage carousel
$('.featured__collection').slick({
    dots: false,
    autoplay: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Prev" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#145C97" fill-rule="nonzero"></path></svg></button>',
    nextArrow: '<button id="slick-next" class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#145C97" fill-rule="nonzero"></path></svg></button>',
    responsive: [
        {
            breakpoint: 769,
            settings: {
                arrows: false,
            }
        },
        {
            breakpoint: 550,
            settings: {
                arrows: false,
                slidesToShow: 1,
                dots: true,
            }
        }
    ]
});
var slides = $('.collection__list-section .grid__item .grid').attr('data-slides');
function collectionSlick(){
    if(slides >= '6') {
        $('.collection__list-section .grid__item .grid').slick({
            dots: true,
            autoplay: false,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Prev" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#FFFFFF" fill-rule="nonzero"></path></svg></button>',
            nextArrow: '<button id="slick-next" class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.687 2.01L5.409 7.384.132 2.01 1.5.616l3.908 3.98L9.318.616z" fill="#FFFFFF" fill-rule="nonzero"></path></svg></button>',
            responsive: [
                {
                    breakpoint: 769,
                    settings: "unslick"
                }
            ]
        
        });
    }
}
const sl =  $('.collection__list-section .grid__item .grid');
$(window).on('resize', function() {
    if( $(window).width() >= 768 &&  !sl.hasClass('slick-initialized')) {
          collectionSlick();
    }
 });
 if( $(window).width() >= 768 &&  !sl.hasClass('slick-initialized')) {
    collectionSlick();
}

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function(e) {
    e.preventDefault()
    $newAddressForm.toggleClass('hide');
    $('.addresses_main__content').toggleClass('hide');
    $('.page-address__content').toggleClass('form_show');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.addresses_main__content').toggleClass('hide');
    $('.page-address__content').toggleClass('form_show');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
    $('#CustomerLoginForm').addClass('posted');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Bottom to Top Button

  var btn = $('#button');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });

  // Footer Accordion

  function footerAccordion(){
    $(document).on('click','.site-footer__content .h4.link',function(){
      var el = $(this);
      $(el).siblings('.site-footer__linklist').slideToggle();
      $(el).toggleClass('active');
    })
  }
  if($(window).width() <= 1023) {
    $('.site-footer__content .h4').addClass('link');
    footerAccordion();
  } else {
    $('.site-footer__content .h4').removeClass('link');
    $('.site-footer__linklist').removeAttr('style');
    $('.site-footer__content .h4').removeClass('active');
    footerAccordion();
  }
  $(window).on('resize',function(){
    if($(window).width() <= 1023) {
      $('.site-footer__content .h4').addClass('link');
    } else {
      $('.site-footer__content .h4').removeClass('link');
      $('.site-footer__linklist').removeAttr('style');
      $('.site-footer__content .h4').removeClass('active');
    }
  })
  
  $('nav[role="navigation"] .has_subnav > a').hover(
    function() {
        $(this).attr("aria-expanded", true);
    },

    function() {
        $(this).attr("aria-expanded", false);
    }
  );
  
  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  $(document).on('keyup', 'input#ContactFooter-email', function(e) {
    var user_entered_email = $(this).val();
    
    if ( isEmail(user_entered_email) == true ) {
      $(this).attr('aria-invalid', false);
    }
    else {
      $(this).attr('aria-invalid', true);
    }
  });

});

site = {
    isMobile: false,
    browserWidth: 0,
    setBrowserWidth: function() {
        site.browserWidth =
        window.innerWidth || document.documentElement.clientWidth;
    },
    checkForMobile: function() {
      if(site.browserWidth < 1024) {
        site.isMobile = true
      }
    },
    initNavigation: function() {

        var $header = $('.site-header'),
            $searchToggle = $('.toggle-mobile-search'),
            $navToggle = $('.toggle-nav'),
            $navOverlay = $('.nav-overlay'),
            $togglers = $('li.has_subnav a.toggler'),
            $returns = $('li.has_subnav li.return');

        $searchToggle.on('click tap', function(e) {
          e.preventDefault();
          e.stopPropagation();
          $('#mobile_search input[name="q"]').focus();
          $('.js-searchForm').toggle().find('input[name="q"]').focus();
          if(site.browserWidth > 767) {
            $('.js-searchOpen').toggle();
            $('.js-searchClose').toggle();
          }
        });
        
        $navToggle.on('click tap', function(e) {
            if(site.isMobile) {
              e.preventDefault();
              e.stopPropagation();
            }
            if ($header.hasClass('nav-open')) {
                $header.removeClass('nav-open');
                $navOverlay.fadeOut(300);
            } else {
                $navOverlay.fadeIn(300, function() {
                    $header.addClass('nav-open');
                });
            }
        });

        $togglers.on('click tap', function(e) {
            if(site.isMobile) {
              e.preventDefault();
              e.stopPropagation();
            }
            $(this).next('ul').addClass('is-open');
        });

        $returns.on('click tap', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parent('ul').removeClass('is-open');
        });
        
    },
    initAccordions: function(){
      $(".js-toggleBtn").on("click", function(e) {
        $(this)
          .next(".js-toggleContent")
          .slideToggle();
        $(this).toggleClass("is-open");
        e.preventDefault();
      });
    },
    initAppendAround: function(){
      $(".js-appendaroundContent").appendAround();
    },
    run: function() {
        site.setBrowserWidth();
        site.checkForMobile();
        site.initNavigation();
        site.initAccordions();
        site.initAppendAround();
    },
    helpers: {
        debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                  args = arguments;
                var later = function() {
                  timeout = null;
                  if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
};

var triggerResize = site.helpers.debounce(function() {
    if ($(this).width() != site.browserWidth) {
        site.setBrowserWidth();
        site.checkForMobile();
    }
}, 250);

site.run();
window.addEventListener("resize", triggerResize);

// test for touch events support and if not supported, attach .no-touch class to the HTML tag.
if (!("ontouchstart" in document.documentElement)) {
    document.documentElement.className += " no-touch";
}

// Function to set and get Cookies
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
// End function to get cookies

// Handle show/hide of collection description on PLP Collection pages
$(document).ready(function () {
  if ( $('body.template-collection').length > 0 && $('.bc-sf-filter-collection-description').length > 0 ) {

    $(document).on('click', '#bc-sf-filter-bottom-pagination a', function (e) {
      // store the clicked link's text value (the page number of the pagination link)
      var paginated_link_value = $(this).attr('href');
      
      if (paginated_link_value.indexOf("?page=") < 0) {
        // Show collection description on page 1
        $('.bc-sf-filter-collection-description').show();
      }
      else {
        // Hide collection description on not-page-1
        $('.bc-sf-filter-collection-description').hide();
      }
    });
  
  }
});
